module.exports = __webpack_public_path__ + "static/ic-antun-31f3fb0ede494d8a54a9ce63856192f5.png";